import React, { useEffect, useState } from "react";

import { Card } from "@lightspeed/flame/Card";

import { Bone } from "@lightspeed/cirrus/Bone";
import { Table, Td, Tr } from "@lightspeed/cirrus-table";

const Loader = ({ location }) => {
  const [showSpinner, setShowSpinner] = useState(true);
  useEffect(() => {
    let timer1 = setTimeout(() => setShowSpinner(false), 7000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);
  return showSpinner && !location ? (
    <Card top="true">
      <Table>
        <tbody>
          {"1 2 3 4 5 6 7 8 9 10".split(" ").map(() => (
            <Tr key={Math.random() * 9999}>
              <Td>
                <Bone />
              </Td>
              <Td>
                <Bone />
              </Td>
              <Td>
                <Bone />
              </Td>
              <Td>
                <Bone />
              </Td>
              <Td textAlign="right">
                <Bone />
              </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </Card>
  ) : (
    <div className="loader-no-item">
      <h3>No items</h3>
    </div>
  );
};

export default Loader;
